
import { useQuery } from '@tanstack/react-query';
import { SubscriptionFeatures } from './types';
import { fetchUserSubscription } from './useUserSubscriptions';

// Fetch subscription features for current user
export const fetchSubscriptionFeatures = async (): Promise<SubscriptionFeatures> => {
  try {
    console.log('Fetching subscription features...');
    const userSubscription = await fetchUserSubscription();
    
    if (!userSubscription || !userSubscription.plan) {
      console.log('No active subscription found, returning default features');
      return {
        currency_conversion: false,
        multiple_currencies: false,
        price_comparison: false,
        grouped_contracts: false,
        contract_services: false,
        reminders: false,
        payment_type_selection: false,
        dashboard: false,
        contract_pdf_email: false
      };
    }
    
    console.log('Subscription features loaded:', userSubscription.plan.features);
    return userSubscription.plan.features;
  } catch (error) {
    console.error('Error fetching subscription features:', error);
    throw error;
  }
};

// React Query hook for subscription features
export const useSubscriptionFeaturesQuery = (options = {}) => 
  useQuery({
    queryKey: ['subscription-features'],
    queryFn: fetchSubscriptionFeatures,
    retry: 3,
    retryDelay: 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    ...options
  });

export const useFeaturesHooks = () => {
  return {
    useSubscriptionFeaturesQuery
  };
};
